import React, { useContext, useMemo } from 'react';
import { useExodus } from '@exodus/headless-react';
import ms from 'ms';
import { QuotesManager } from '../../quotes/quotes-manager.js';
const initialValue = {
    value: null,
};
const GET_QUOTE_INTERVAL = ms('30s');
export const QuotesContext = React.createContext(initialValue);
export const useQuotesManagerContext = () => useContext(QuotesContext);
export const QuoteManagerProvider = ({ children }) => {
    const exodus = useExodus();
    const contextValue = useMemo(() => ({
        value: new QuotesManager({
            getBestQuote: exodus.exchange.getBestQuote,
            bestQuotePollIntervalMs: GET_QUOTE_INTERVAL,
        }),
    }), [exodus.exchange.getBestQuote]);
    return React.createElement(QuotesContext.Provider, { value: contextValue }, children);
};
